export default __webpack_public_path__ + "static/solidana_eco-dc7a19643cd1fceee08db460ea660303.pdf";